module.exports = __webpack_public_path__ + "img/chat_emoticon_tipos_04.png?8b802320a1d7223cf9d7645de91ce0a9";